import excelJS from 'exceljs'
import { save } from 'save-file'
import _ from 'lodash'

const baseColumns = [
  { name: "Template Name", item: "name", width: 100 },
  { name: "Template ID", item: "template_id", width: 100 },
  { name: "Active Passes", item: "active_count", width: 100 },
  { name: "Expired Passes", item: "expired_count", width: 100 },
  { name: "Apple Installs", item: "apple_install_count", width: 100 },
  { name: "Google Installs", item: "google_install_count", width: 100 },
]

const passesListToExcel = async ({ fileName, data }) => {

  const columns = baseColumns

  const workbook = new excelJS.Workbook()

  workbook.views = [
    {
      x: 0, y: 0, width: 3, height: 1000,
      firstSheet: 0, activeTab: 1, visibility: 'visible'
    }
  ]

  const font = { name: 'Courier', size: 12, bold: true }

  const passes_worksheet = workbook.addWorksheet("active passes")

  columns.map((col, idx) => passes_worksheet.getColumn(idx + 1).width = col.width)

  const passes_row = passes_worksheet.getRow(1)

  columns.map((col, idx) => passes_row.getCell(idx + 1).value = col.name)

  columns.map((col, idx) => passes_row.getCell(idx + 1).font = font)

  data.map((r, i) => {
    const row = passes_worksheet.getRow(i + 2)

    columns.map((col, idx) =>
      row.getCell(idx + 1).value = _.get(r, col.item))
    columns.map((col, idx) =>
      row.getCell(idx + 1).font = font)
  })


  const buffer = await workbook.xlsx.writeBuffer()

  await save(buffer, fileName + '.xlsx')
}

export default passesListToExcel
